import { render, staticRenderFns } from "./FirebaseController.vue?vue&type=template&id=bff8ed1c"
import script from "./FirebaseController.vue?vue&type=script&lang=js"
export * from "./FirebaseController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports